module.exports = __webpack_public_path__ + "media/images/ioscor_logo-620eb0ea39a971797020b9d16b95bfa6.svg";